var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconMessage',{attrs:{"icon":"icon-monitoring","message-key":"legacy.project.select"}})
}
var staticRenderFns = []

export { render, staticRenderFns }